import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppGlobal } from './app.global';

/** Adress of API Server */
const endpoint = environment.Endpoint;
const backendEndpoint = environment.backendEndpoint;

@Injectable({
  providedIn: 'root'
})
export class MccService {

  countriesList: Observable<any>;

  /** base url for requests */
  baseUrl  = '/api/mcc';
  baseUrl2 = /* 'http://localhost:3030/api/v1/mcc';  // */ '/api/v1/mcc';
  endUrl   = '';

  curVersion = 1;
  private countries = new BehaviorSubject<any[]>([]);

  constructor(private httpClient: HttpClient, private app: AppGlobal) {
    this.curVersion = this.app.userVer || 2; // environment.globalVer || 1;
    this.endUrl     = (this.curVersion === 1 ? endpoint + this.baseUrl : backendEndpoint + this.baseUrl2);

    this.countriesList = this.countries.asObservable();
  }

  getAllForFilter(concat: string) {
    return this.httpClient.get<any>(this.endUrl + '/forFilter/' + concat);
  }

  updateCountriesList(newCountries){
    this.countries.next(newCountries);
  }

  getCountries(): Observable<any[]> {
    return this.countriesList;
  }

  async getCountriesList(concat: string) {
    this.httpClient.get<any>(this.endUrl + '/forFilter/' + concat).toPromise().then((data: any[]) => {
      this.updateCountriesList(data);
    });
  }

}
